import RootStore from './RootStore';

export const rootStore = new RootStore();
